import { supportedEnglishAccents } from "../ruleSets/accentRules";
import { supportedLanguageItems } from "../ruleSets/allRules";
import { supportedSpanishAccents } from "../ruleSets/spanishToIpa";
import { allSpeakVariants } from "../speak/meSpeak";
import { PartError } from "./parseParts";
import { PartLanguage, PartOptions } from "./parts";

/** validate the values in 'part' are recognized & supported */
export function validateLanguagePart(part?: PartLanguage): true | PartError {
  if (part === undefined) {
    return true;
  }

  // language
  if (!supportedLanguageItems.includes(part.language)) {
    return { partError: 'unsupported language', content: part.language };
  }
  // accent
  if (part.accent
    && !supportedEnglishAccents.includes(part.accent)
    && !supportedSpanishAccents.includes(part.accent)
    && part.accent !== 'none'
  ) {
    return { partError: 'unsupported accent', content: part.accent };
  }
  return true;
}

/** validate the values in 'part' are recognized & supported */
export function validateOptionsPart(part?: PartOptions): true | PartError {
  if (part === undefined) {
    return true;
  }
  if (part.voice && !allSpeakVariants.includes(part.voice)) {
    return { partError: 'unsupported variant', content: part.voice };
  }
  if (!validateNumber(part.volume)) {
    return { partError: 'invalid number', content: JSON.stringify(part.volume) };
  }
  if (!validateNumber(part.pitch)) {
    return { partError: 'invalid number', content: JSON.stringify(part.pitch) };
  }
  if (!validateNumber(part.speed)) {
    return { partError: 'invalid number', content: JSON.stringify(part.speed) };
  }
  if (!validateNumber(part.wordgap)) {
    return { partError: 'invalid number', content: JSON.stringify(part.wordgap) };
  }
  if (!validateNumber(part.pan)) {
    return { partError: 'invalid number', content: JSON.stringify(part.pan) };
  }
  return true;
}

function validateNumber(n?: number): boolean {
  return n === undefined ? true : typeof (n) === 'number';
}
